/* Cleantalk Modal object */
spbcModal = {

    // Flags
    loaded: false,
    loading: false,
    opened: false,
    opening: false,

    // Methods
    load: function( action ) {
        if ( ! this.loaded ) {
            this.loading = true;
            callback = function( result, data, params, obj ) {
                spbcModal.loading = false;
                spbcModal.loaded = result;
                document.dispatchEvent(
                    new CustomEvent( 'spbcModalContentLoaded', {
                        bubbles: true,
                    } ),
                );
            };
            if ( typeof spbcSendAJAXRequest === 'function' ) {
                spbcSendAJAXRequest( {'action': action}, {'callback': callback, 'notJson': true} );
            }
        }
    },

    putError: function( errorText ) {
        let html = '<h2>The error occurred</h2>' +
            '<p>' + errorText + '</p>' +
            '<a style="text-align: left;' +
            'margin-top: 40px;" target="_blank"' +
            'href="https://wordpress.org/support/plugin/security-malware-firewall">Contact tech support</a>';
        this.put(html);
    },

    put: function( html ) {
        spbcModal.loading = false;
        spbcModal.loaded = html;
        document.dispatchEvent(
            new CustomEvent( 'spbcModalContentLoaded', {
                bubbles: true,
            } ),
        );
    },

    confirm: function(html, text = '', callback) {
        spbcModal.loading = false;
        let contentBlock = document.getElementById('spbc-modal-content');
        if (contentBlock) {
            contentBlock.innerHTML = '';

            const headerBlock = document.createElement('div');
            headerBlock.className = 'spbc-modal-header';
            headerBlock.textContent = html;
            contentBlock.append(headerBlock);

            // Create text block
            const textBlock = document.createElement('div');
            textBlock.className = 'spbc-modal-text-block';
            contentBlock.append(textBlock);

            const textElem = document.createElement('div');
            textElem.className = 'spbc-modal-text';
            textElem.textContent = `If you agree, the file ${text} will be deleted`;
            textBlock.append(textElem);

            // Create buttons block
            const buttonsBlock = document.createElement('div');
            buttonsBlock.className = 'spbc-modal-buttons-block';
            contentBlock.append(buttonsBlock);

            const yesButton = document.createElement('button');
            yesButton.className = 'spbc-modal-button';
            yesButton.textContent = 'Yes';
            yesButton.onclick = function() {
                callback(true);
                spbcModal.close();
            };
            buttonsBlock.append(yesButton);

            const noButton = document.createElement('button');
            noButton.className = 'spbc-modal-button';
            noButton.textContent = 'No';
            noButton.onclick = function() {
                spbcModal.close();
            };
            buttonsBlock.append(noButton);
        }
        document.dispatchEvent(
            new CustomEvent( 'spbcModalContentLoaded', {
                bubbles: true,
            } ),
        );
    },

    open: function() {
        /* Cleantalk Modal CSS start */
        let renderCss = function() {
            let cssStr = '';
            for ( key in this.styles ) {
                if (key) {
                    cssStr += key + ':' + this.styles[key] + ';';
                }
            }
            return cssStr;
        };
        let overlayCss = {
            styles: {
                'z-index': '9999',
                'position': 'fixed',
                'top': '0',
                'left': '0',
                'width': '100%',
                'height': '100%',
                'background': 'rgba(0,0,0,0.5)',
                'display': 'flex',
                'justify-content': 'center',
                'align-items': 'center',
            },
            toString: renderCss,
        };
        let innerCss = {
            styles: {
                'position': 'relative',
                'padding': '20px',
                'margin': '10px',
                'max-width': '550px',
                'max-height': '500px',
                'background': '#FFF',
                'border': '1px solid rgba(0,0,0,0.75)',
                'border-radius': '4px',
                'box-shadow': '7px 7px 5px 0px rgba(50,50,50,0.75)',
            },
            toString: renderCss,
        };
        let closeCss = {
            styles: {
                'position': 'absolute',
                'background': '#FFF',
                'width': '20px',
                'height': '20px',
                'border': '2px solid rgba(0,0,0,0.75)',
                'border-radius': '15px',
                'cursor': 'pointer',
                'top': '-8px',
                'right': '-8px',
            },
            toString: renderCss,
        };
        let closeCssBefore = {
            styles: {
                'content': '""',
                'display': 'block',
                'position': 'absolute',
                'background': '#000',
                'border-radius': '1px',
                'width': '2px',
                'height': '16px',
                'top': '2px',
                'left': '9px',
                'transform': 'rotate(45deg)',
            },
            toString: renderCss,
        };
        let closeCssAfter = {
            styles: {
                'content': '""',
                'display': 'block',
                'position': 'absolute',
                'background': '#000',
                'border-radius': '1px',
                'width': '2px',
                'height': '16px',
                'top': '2px',
                'left': '9px',
                'transform': 'rotate(-45deg)',
            },
            toString: renderCss,
        };
        let contentCss = {
            styles: {
                'display': 'grid',
                'gap': '20px',
                'overflow-y': 'auto',
                'max-height': '460px',
                'overflow-x': 'hidden',
            },
            toString: renderCss,
        };
        let bodyCss = {
            styles: {
                'overflow': 'hidden',
            },
            toString: renderCss,
        };
        let spbcModalStyle = document.createElement( 'style' );
        spbcModalStyle.setAttribute( 'id', 'spbc-modal-styles' );
        spbcModalStyle.innerHTML = 'body.spbc-modal-opened{' + bodyCss + '}';
        spbcModalStyle.innerHTML += '#spbc-modal-overlay{' + overlayCss + '}';
        spbcModalStyle.innerHTML += '#spbc-modal-close{' + closeCss + '}';
        spbcModalStyle.innerHTML += '#spbc-modal-close:before{' + closeCssBefore + '}';
        spbcModalStyle.innerHTML += '#spbc-modal-close:after{' + closeCssAfter + '}';
        spbcModalStyle.innerHTML += '#spbc-modal-content{' + contentCss + '}';
        document.body.append( spbcModalStyle );
        /* Cleantalk Modal CSS end */

        let overlay = document.createElement( 'div' );
        overlay.setAttribute( 'id', 'spbc-modal-overlay' );
        document.body.append( overlay );

        document.body.classList.add( 'spbc-modal-opened' );

        let inner = document.createElement( 'div' );
        inner.setAttribute( 'id', 'spbc-modal-inner' );
        inner.setAttribute( 'style', innerCss );
        overlay.append( inner );

        let close = document.createElement( 'div' );
        close.setAttribute( 'id', 'spbc-modal-close' );
        inner.append( close );

        let content = document.createElement( 'div' );
        if ( this.loaded ) {
            content.innerHTML = this.loaded;
        } else {
            content.innerHTML = 'Loading...';
        }
        content.setAttribute( 'id', 'spbc-modal-content' );
        inner.append( content );

        this.opened = true;

        return this;
    },

    close: function() {
        spbcModal.loaded = '';
        spbcModal.loading = false;
        document.body.classList.remove( 'spbc-modal-opened' );
        document.getElementById( 'spbc-modal-overlay' ).remove();
        document.getElementById( 'spbc-modal-styles' ).remove();
        document.dispatchEvent(
            new CustomEvent( 'spbcModalClosed', {
                bubbles: true,
            } ),
        );
    },

};

/* Cleantalk Modal helpers */
document.addEventListener('click', function( e ) {
    if ( e.target && e.target.id === 'spbc-modal-overlay' || e.target.id === 'spbc-modal-close' ) {
        spbcModal.close();
    }
});
document.addEventListener('spbcModalContentLoaded', function( e ) {
    if ( spbcModal.opened && spbcModal.loaded ) {
        document.getElementById( 'spbc-modal-content' ).innerHTML = spbcModal.loaded;
    }
});
